import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../auth/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class OperationService {
  api = inject(ApiService);

  getOperationStatus(signature: string) {
    const obs = this.api.getOperationStatus(signature);
    return obs;
  }

  lockPriceWidget(signature: string) {
    const obs = this.api.lockPriceWidget(signature);
    return obs;
  }

  checkCompliance(signature: string) {
    const obs = this.api.checkCompliance(signature);
    return obs;
  }

  sendRules(signature: string) {
    const obs = this.api.sendRules(signature);
    return obs;
  }
}
